import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { useState } from "react";
import { useAppDispatch } from "../../../../store/hooks";
import { pushModal } from "../../../../store/slices/modalsSlice";
import GeneralMessageModal from "../../../Modals/GeneralMessageModal";
import { handleDeleteQuestion, trimQuestion } from "../utils";

function Qimg({
  question,
  src,
  alt,
  maxHeight = 1000,
  border = "1px solid #ddd",
  paragraph,
  weight,
  deleteButton = false,
  setQuestionsData,
  questionsData,
}) {
  const [imageKey, setImageKey] = useState(0); // Add a key state

  const handleImageError = () => {
    // Image failed to load, so let's attempt to reload it
    setImageKey(imageKey + 1); // Change the key to force a re-render
  };

  const [loading, setLoading] = useState(false);

  const dispatch = useAppDispatch();

  const errorFn = () => {
    dispatch(pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />));
  };

  return (
    <div className="p-2 border border-gray-400 rounded-lg flex flex-col justify-between">
      <img
        key={imageKey} // Use the key to force a re-render when needed
        className="card-img-top w-full rounded-lg"
        style={{ maxHeight: maxHeight, border: border }}
        src={decodeURIComponent(src)}
        alt={alt}
        onError={handleImageError}
      />
      <div className="flex justify-between items-start my-2 gap-4">
        <div className="flex flex-col gap-1 grow">
          <p>رأس السؤال : {trimQuestion({ paragraph, limit: 200 })}</p>
          <p>الدرجة : {weight}</p>
        </div>
        {deleteButton && (
          <Button
            variant="destructive"
            disabled={loading}
            onClick={() =>
              handleDeleteQuestion({
                qId: question.id,
                setLoading,
                setQuestionsData,
                questionsData,
                errorFn,
              })
            }
          >
            <Trash2 className="size-4" />
          </Button>
        )}
      </div>
    </div>
  );
}

export default Qimg;
